import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const Pricing = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  return (
    <section className="section shadow-sm lazyloaded" id="pricing">
      <span className="section-link"></span>
      <h2 className="head text-capitalize text-center">{project} - Pricing</h2>
      <div className="pricing-div text-center">
        <div className="price-card">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>2 BHK</h3>
          <h4>Price Breakup</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            On Request
          </button>
        </div>
        <div className="price-card">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>3 BHK</h3>
          <h4>Price Breakup</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            On Request
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
